import { DrawerSection } from '@components/ui/drawer/section';
import { SchedulerSidebarCrewMember } from './member';
import { SchedulerSidebarCrewMultiSelect } from './multiSelect';
import { useSchedulerSidebar } from '@contexts/scheduler/sidebar';
import { useDropdownsContext } from '@contexts/dropdowns';
import { useSchedulerContext } from '@contexts/scheduler';
import { isManuallyAdded } from './helpers';
import { useAccess } from '@hooks/access';
import { SchedulerSidebarResourcesRequirements } from '../requirements';
import { defaultCrewRequirement } from './constants';
import { requirement as requirementType } from '../requirements/types';
import { useEffect, useState } from 'react';

export type SchedulerSidebarCrewProps = {
  expanded: boolean;
  onExpandedChange: (expanded: boolean) => void;
};

export const SchedulerSidebarCrew = ({ expanded, onExpandedChange }: SchedulerSidebarCrewProps) => {
  const [requirement, setRequirement] = useState<requirementType>();

  const {
    crewMembers,
    disabled,
    setState,
    currentSchedule: {
      task: { requirements },
    },
  } = useSchedulerSidebar();
  const access = useAccess();
  const {
    active: { schedule },
  } = useSchedulerContext();
  const { fieldUsers } = useDropdownsContext();
  const notDeactivatedCrews = crewMembers.filter((el) => !el.discardedAt && !el.userDeactivated);
  const taskRequirements =
    schedule?.id === 'new' ? [defaultCrewRequirement(notDeactivatedCrews.length)] : requirements;

  useEffect(() => {
    const crewRequirement = requirements?.find((el) => el.requirementType === 'crew_member');
    if (!crewRequirement) return;

    setRequirement({ ...crewRequirement, currentlyAssigned: notDeactivatedCrews.length || 0 });
  }, [requirements, setRequirement, crewMembers]);

  const isEditingMember = crewMembers.some((el) => el.edit);

  const crewMembersWithManuallyAddedInfo = crewMembers.map((el) => ({
    ...el,
    manuallyAdded: isManuallyAdded(el.userId, schedule.foreman?.id, fieldUsers),
  }));

  const titleObject = (
    <SchedulerSidebarResourcesRequirements
      scheduleStatus={'draft'}
      requirement={requirement || defaultCrewRequirement(0)}
      onChangeAmount={(value) =>
        setState((prev) => ({
          ...prev,
          currentSchedule: {
            ...prev.currentSchedule,
            task: {
              ...prev.currentSchedule.task,
              requirements: taskRequirements?.map((el) =>
                el.id === requirement?.id ? { ...el, totalNeeded: value } : el,
              ),
            },
          },
        }))
      }
    />
  );

  return (
    <DrawerSection
      titleObject={titleObject || null}
      disabled={disabled}
      expanded={expanded}
      onExpandedChange={onExpandedChange}
      className="flex flex-col border-t-0 p-2">
      <div className="flex flex-col gap-2">
        {!access.readOnly && (
          <SchedulerSidebarCrewMultiSelect disabled={disabled || isEditingMember} />
        )}
        <div>
          <div className="grid grid-cols-[34px_auto_34px_34px] items-center gap-y-2">
            {crewMembersWithManuallyAddedInfo.map((el) => (
              <SchedulerSidebarCrewMember key={el.userId} data={el} />
            ))}
          </div>
        </div>
      </div>
    </DrawerSection>
  );
};
